import { render } from "./AddArrondissementModal.vue?vue&type=template&id=77a86b3a&ts=true"
import script from "./AddArrondissementModal.vue?vue&type=script&lang=ts"
export * from "./AddArrondissementModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__